package dev.lingvo.site.pages.app.projects.slug.screenshots

import dev.lingvo.shared.DeviceClass

/** Stable anchors keep discussion attached to saved content as the canvas selection changes. */
internal data class CanvasReviewAnchor(val version: Int, val slotId: String, val locale: String, val layerId: String? = null)

/** A slot-wide view includes its layer discussions; selecting a layer narrows that view exactly. */
internal fun canvasReviewAnchorMatches(
    anchor: CanvasReviewAnchor, version: Int, slotId: String, locale: String, layerId: String?,
): Boolean = anchor.version == version && anchor.slotId == slotId && anchor.locale == locale &&
    (anchor.layerId == null || anchor.layerId == layerId)

/** Device-specific marks never cross saved versions, even when a replacement looks identical. */
internal fun canvasReviewRenderMatches(
    anchor: CanvasReviewAnchor, device: DeviceClass, version: Int, slotId: String, locale: String,
    renderDevice: DeviceClass, valid: Boolean,
): Boolean = valid && anchor.version == version && anchor.slotId == slotId && anchor.locale == locale && device == renderDevice
